<template>
  <div class="join">
    <div class="banner1" @click="dialogVisible=true"></div>

    <ul class="adv1 container1">
      <li class="adv_item" v-for="(v,i) in adv1List" :key="i">
        <div class="img"><img v-lazy="v.src" alt=""></div>
        <p class="p1">{{ v.title }}</p>
        <p class="p2">{{ v.subTitle }}</p>
      </li>
    </ul>

    <div class="banner2 com_banner">
      <div class="container1">
        <ul class="fl_right">
          <h3 class="com_title">我们招募的对象有哪些？</h3>
          <li>1.家具工厂</li>
          <li>2.装企</li>
          <li>3.服务商</li>
          <li>4.城市合伙人</li>
          <li>整装时代最优秀的家具软装供应链综合性服务平台多比网，诚挚邀请您一起携手共进，把握新机遇，共谋新发展！</li>
        </ul>
      </div>
    </div>

    <div class="banner3 com_banner">
      <ul class="container1">
        <h3 class="com_title">我们需要的合作伙伴是怎样的？</h3>
        <li>1.专注于某一家具领域，技术力量深厚，具有良好行业知名度和美誉度的家具工厂</li>
        <li>2.对一站式家具供应链服务的赋能平台有需求的装饰公司</li>
        <li>3.能够提供完善家具交付服务的家具经销商</li>
        <li>4.在当地有一定装饰建材行业人脉的人</li>
      </ul>
    </div>

    <div class="adv2 container1">
      <h3 class="com_title">我们能为合作伙伴做什么？</h3>
      <ul class="content">
        <li class="item" v-for="(v,i) in adv2List" :key="i">
          <div class="img"><img v-lazy="v.src" alt=""></div>
          <p class="title">{{v.title}}</p>
          <p class="text">{{ v.subTitle }}</p>
        </li>
      </ul>
    </div>

    <div class="banner4 com_banner">
      <div class="container1 content">
        <h3 class="com_title">他们都已经成为我们的合作伙伴</h3>
        <div class="pos1 com_popover">
          对家居互联网一直比较关注，飞到成都和他们CEO罗总一直聊到深夜，觉得是一支非常靠谱的团队，一定是可以成功的
        </div>
        <div class="pos2 com_popover">
          做家装很多年，一直在看项目，偶尔从朋友那里了解到多比网城市合伙人项目，电话咨询后就来了成都详细了解，决定大干一场
        </div>
        <div class="pos3 com_popover">
          去了成都3次考察他们公司，详细了解了他们的平台及模式，加上自身拥有这方面的资源，决定加盟他们成为城市独家服务商
        </div>
        <div class="pos4 com_popover">
          这几年装企生意难做，终于找到了一个靠谱的家具供应链综合性服务平台，彻底解决了家具产品品类、物流、安装、售后等问题
        </div>
        <div class="pos5 com_popover">
          展会期间去了贵公司了解项目，团队执行力非常强，值得加入成为品牌家具战略合作商，一起共创辉煌
        </div>
      </div>
    </div>

    <div class="process container1">
      <h3 class="com_title">如何加入多比网城市独家服务商？</h3>
      <div class="content">
        <ul class="line">
          <li v-for="(v,i) in 80" :key="i"></li>
        </ul>
        <div class="item pro1">
          <img :src="process1" alt="">
          <p>资料审核</p>
        </div>
        <div class="item pro2">
          <img :src="process2" alt="">
          <p>筹备体验馆</p>
        </div>
        <div class="item pro3">
          <img :src="process3" alt="">
          <p>掘金本地市场</p>
        </div>
        <div class="item pro4">
          <img :src="process4" alt="">
          <p>提交申请</p>
        </div>
        <div class="item pro5">
          <img :src="process5" alt="">
          <p>成为城市合伙人</p>
        </div>
        <div class="item pro6">
          <img :src="process6" alt="">
          <p>筹备体验馆及培训</p>
        </div>
      </div>
    </div>

    <div class="about container1">
      <h3 class="com_title">联系方式</h3>
      <div class="concat">
        <div class="phone_box item">
          <img class="img" :src="phone" alt="">
          <p class="p1">联系方式</p>
          <p class="p2">028-65042668</p>
        </div>
        <div class="qr_code_box item">
          <img class="img" :src="qrcode" alt="">
          <p class="p1">（咨询我们）</p>
        </div>
      </div>
      <a class="map" target="_blank" href="https://map.baidu.com/search/%E5%A4%9A%E6%AF%94%E7%BD%91%E8%90%A5%E9%94%80%E4%B8%AD%E5%BF%83/@11571591.555,3560893.41,19z?querytype=s&da_src=shareurl&wd=%E5%A4%9A%E6%AF%94%E7%BD%91%E8%90%A5%E9%94%80%E4%B8%AD%E5%BF%83&c=75&src=0&wd2=%E6%88%90%E9%83%BD%E5%B8%82%E5%8F%8C%E6%B5%81%E5%8C%BA&pn=0&sug=1&l=19&b=(11571297.530772164,3560660.1845778674;11571926.032531265,3560966.841061161)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&sug_forward=2cdffd9fb33af7ad38221c9f&seckey=c6d9c7e05d7e627c56ed46fab5d7c5c792064779599d5e12b955a6f18a1204375d1588206c94d22e4bdd1ade0ad06e78c21917e24c6223b96bc51b75ca38651a989e9bdaac4236ae249d89d81d8f619d5fc6fa10eb9f5c2a76d87b38fb4e9734a4020e88300c49d8d705ef4ba1a6c3e4e1611ca851644495ec860b56513bf826614b47469dd792744af7a50b575cc7f0151db4995dd08b0644642ac226cf798a6450ae6f6c312c7c47b40643dc54a001d40d9dfc5e4a83acd1f97764933a5444c93839fc1376b2931dcf38d616d90cf93fd24d3cd53c7492bc501e1ae0b1fdd2b14d9904424819a8b90de9d3f93ab24b&device_ratio=1">
        <img :src="bmapimg" alt="">
      </a>
    </div>

    <div class="sign_up">
      <el-button @click="dialogVisible = true">点击报名成为城市合作商</el-button>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="900px" :before-close="beforeClose">
      <div class="header">
        <h2>我要加入，成为</h2>
        <el-radio-group v-model="formData.type">
          <el-radio :label="4">城市合伙人</el-radio>
          <el-radio :label="3">品牌供货商</el-radio>
          <el-radio :label="5">合作装企</el-radio>
        </el-radio-group>
        <p class="itr">请填写您的个人信息，多比网招商经理会在2个工作日内与您联系，也可以拨打服务热线028-65042668</p>
      </div>

      <el-form class="my_form" ref="form" :model="formData" :rules="rules" label-width="280px">
        <el-form-item label="你的意向合作城市：" prop="areaCode">
          <cascader-city :isLevel="true" ref="casCity" :GetProList="GetProList" :GetDisList="GetDisList" :GetTownList="GetTownList" @getEndPlace="getEndPlace"></cascader-city>
        </el-form-item>
        <el-form-item label="你从事过的行业：" prop="scopeList">
          <el-checkbox-group v-model="formData.scopeList">
            <el-checkbox :label="32">家具制造</el-checkbox>
            <el-checkbox :label="2">装修公司</el-checkbox>
            <el-checkbox :label="4">家具店</el-checkbox>
            <el-checkbox :label="8">建材店</el-checkbox>
            <el-checkbox :label="16">其他</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="手机号：" prop="linkPhone">
          <el-input v-model="formData.linkPhone" placeholder="请填写您的手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="verCode">
          <el-input v-model.trim="formData.verCode" placeholder="请填写验证码">
            <template slot="append">
              <el-button class="append_btn" :disabled="downTime > 0" @click="sendVerCode">
                {{ downTime > 0 ? downTime + "秒后重发" : "获取验证码" }}
              </el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="linkPerson">
          <el-input v-model="formData.linkPerson" placeholder="请填写您的姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn" type="primary" @click="submitForm">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  SendVerCodeRegister,
  SubmitRegister,
  RegisterCheck,
} from "@/pages/page1/api/modules/user";
import {
  GetProList,
  GetDisList,
  GetTownList,
} from "@/pages/page1/api/modules/common";
import CascaderCity from "@/components/cascaderCity";
import {
  checkVerCode,
  validMobile,
  validatetypeName,
} from "@/pages/publicUtils/validate";
export default {
  metaInfo: { title: "加盟我们 - 多比商城" },
  name: "joinUs",
  components: {
    CascaderCity,
  },
  data() {
    let checkMobile = async (rule, value, callback) => {
      if (!validMobile(value)) {
        return callback(new Error("格式不对"));
      }
      if (value && validMobile(value)) {
        let result = await this.checkPhoneByUrl();
        // console.log("验证手机是否加盟？", result);
        if (result.data.length > 0) {
          //已加盟有数据
          this.$alert(this.msg, `尊敬的${result.data[0].linkPerson}`, {
            confirmButtonText: "我知道了",
            type: "success",
            showClose: false,
            callback: (action) => {
              let newUrl = this.$router.resolve("/");
              window.open(newUrl.href, "_self");
            },
          });
          return callback(new Error("您已加盟"));
        }
        callback();
      }
    };
    let checkPerson = (rule, value, callback) => {
      if (!validatetypeName(value)) {
        return callback(new Error("请输入中文或英文姓名"));
      }
      if (value.length < 2 || value.length > 20) {
        return callback(new Error("长度必须为2-20个字符"));
      }
      callback();
    };
    return {
      GetProList,
      GetDisList,
      GetTownList,
      adv1List: [
        {
          title: "资本",
          subTitle: "顶级知名资本方领投多比网",
          src: require("@/assets/img/join2021_002.png"),
        },
        {
          title: "团队",
          subTitle: "家居行业专家优秀创始团队倾力打造软实力",
          src: require("@/assets/img/join2021_003.png"),
        },
        {
          title: "模式",
          subTitle: "渠道前置模式，一站式家居软装解决方案，全方位服务用户",
          src: require("@/assets/img/join2021_004.png"),
        },
        {
          title: "产品",
          subTitle: "整合全国供应链资源，甄选优质产品，赋能家居新零售",
          src: require("@/assets/img/join2021_005.png"),
        },
      ],
      adv2List: [
        {
          title: "独家代理",
          subTitle: "每个地区仅限一家，利益独享",
          src: require("@/assets/img/join2021_008.png"),
        },
        {
          title: "筹备指导",
          subTitle: "体验馆选址、商品选样、开业筹备等指导",
          src: require("@/assets/img/join2021_009.png"),
        },
        {
          title: "运营支持",
          subTitle: "各大战略合作媒体统一品牌推广，专业系统化的落地运营支持",
          src: require("@/assets/img/join2021_010.png"),
        },
        {
          title: "培训支持",
          subTitle: "定期进行专业全面的团队建设和经营管理培训",
          src: require("@/assets/img/join2021_011.png"),
        },
        {
          title: "技术支持",
          subTitle: "私人化网站定制服务",
          src: require("@/assets/img/join2021_012.png"),
        },
        {
          title: "服务支持",
          subTitle: "物流、安装、售后一站式服务",
          src: require("@/assets/img/join2021_013.png"),
        },
      ],
      process1: require("@/assets/img/join2021_015.png"),
      process2: require("@/assets/img/join2021_016.png"),
      process3: require("@/assets/img/join2021_017.png"),
      process4: require("@/assets/img/join2021_018.png"),
      process5: require("@/assets/img/join2021_019.png"),
      process6: require("@/assets/img/join2021_020.png"),
      phone: require("@/assets/img/join2021_021.png"),
      qrcode: require("@/assets/img/join2021_022.png"),
      bmapimg: require("@/assets/img/bmapimg.jpg"),
      msg: "您的加盟申请我们已经收到，请您耐心等待，我们将尽快与您联系；欢迎您加入多比家具网，我们敬请期待！",
      dialogVisible: false,
      formData: {
        type: 4, // 商家类型

        // 城市
        proName: "",
        proCode: "",
        cityName: "",
        cityCode: "",
        areaName: "",
        areaCode: "",

        scopeList: [], // 经营过的行业
        scope: 0, //后端想要的格式 加起来
        linkPhone: "", //手机
        verCode: "", //验证码
        linkPerson: "", //姓名

        addWay: 2, // 渠道 1微信 2商城
        aloneDo: true,
      },
      rules: {
        areaCode: [{ required: true, message: "必选", trigger: "change" }],
        scopeList: [{ required: true, message: "必选", trigger: "change" }],
        linkPhone: [
          {
            validator: checkMobile,
            required: true,
            message: "必填",
            trigger: "blur",
          },
        ],
        verCode: [
          {
            validator: checkVerCode,
            required: true,
            message: "必填",
            trigger: "blur",
          },
        ],
        linkPerson: [
          {
            validator: checkPerson,
            required: true,
            message: "必填",
            trigger: "blur",
          },
        ],
      },
      downTime: 0,
    };
  },
  methods: {
    getEndPlace(val) {
      this.formData.proCode = val.value[0];
      this.formData.cityCode = val.value[1];
      this.formData.areaCode = val.value[2];
      this.formData.proName = val.label[0];
      this.formData.cityName = val.label[1];
      this.formData.areaName = val.label[2];
      // console.log(val,this.formData);
    },
    sendVerCode() {
      this.$refs.form.validateField("linkPhone", (err) => {
        if (!err) {
          SendVerCodeRegister({ mobile: this.formData.linkPhone }).then(
            (res) => {
              // console.log("获取验证码", res);
              this.formData.verCode = res.data[0].verCode;
              this.downTime = 60;
              let aTime = setInterval(() => {
                this.downTime -= 1;
                //   console.log(this.downTime);
                if (this.downTime <= 0) {
                  clearInterval(aTime);
                }
              }, 1000);
            }
          );
        }
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.formData.scope = 0;
          this.formData.scopeList.forEach((v) => {
            this.formData.scope += v;
          });
          SubmitRegister(this.formData).then((res) => {
            // console.log("提交商家加盟登记接口", res);
            if (res.isSuccess === 1) {
              this.$alert(
                res.data[0].message,
                `尊敬的${res.data[0].customerName}`,
                {
                  confirmButtonText: "我知道了",
                  type: "success",
                  showClose: false,
                  callback: (action) => {
                    let newUrl = this.$router.resolve("/");
                    window.open(newUrl.href, "_self");
                  },
                }
              );
            } else {
              this.$alert(res.message, `发生错误`, {
                confirmButtonText: "确定",
                type: "error",
                showClose: false,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    checkPhoneByUrl() {
      return new Promise((resolve) => {
        let params = { mobile: this.formData.linkPhone, aloneDo: true };
        RegisterCheck(params).then((res) => {
          // console.log("验证手机是否加盟？", res);
          resolve(res);
        });
      });
    },
    // 关闭前的回调
    beforeClose(done) {
      this.$refs.form.resetFields();
      this.$refs.casCity.value = [];
      this.formData.type = 4;
      // 执行关闭
      done();
    },
  },
};
</script>

<style lang="less" scoped>
.join {
  font-size: 12px;
  color: #000000;
  line-height: 1;
  padding-bottom: 20px;
  .banner1 {
    height: 546px;
    background: url("~@/assets/img/banner_join.jpg") no-repeat center;
    background-size: cover;
    cursor: pointer;
  }
  .banner2 {
    margin-top: 160px;
    height: 932px;
    background: url("~@/assets/img/join2021_006.png") no-repeat center;
    .fl_right {
      float: right;
      h3 {
        margin-bottom: 32px;
      }
      li {
        line-height: 26px;
        margin-top: 12px;
        width: 600px;
      }
    }
  }
  .banner3 {
    height: 932px;
    background: url("~@/assets/img/join2021_007.png") no-repeat center;
    h3 {
      margin-bottom: 32px;
    }
    li {
      line-height: 26px;
      margin-top: 12px;
      width: 600px;
    }
  }
  .banner4 {
    height: 932px;
    background: url("~@/assets/img/join2021_014.png") no-repeat center;
    .content {
      position: relative;
      height: 100%;
      .pos1 {
        top: 270px;
        left: 410px;
      }
      .pos2 {
        top: 324px;
        left: 674px;
      }
      .pos3 {
        top: 430px;
        left: 234px;
      }
      .pos4 {
        top: 556px;
        left: 474px;
      }
      .pos5 {
        top: 516px;
        left: 772px;
      }
    }
  }
  .com_banner {
    background-size: cover;
    box-sizing: border-box;
  }
  .com_popover {
    width: 240px;
    padding: 8px 12px;
    border-radius: 8px;
    box-sizing: border-box;
    background: #ffffff;
    font-size: 12px;
    font-weight: bold;
    color: #383838;
    line-height: 18px;
    letter-spacing: 2px;
    position: absolute;
    &::after {
      display: block;
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      left: 38px;
      bottom: -28px;
      border-width: 14px 8px;
      border-style: solid;
      border-color: #ffffff transparent transparent transparent;
    }
  }

  .adv1 {
    display: flex;
    margin-top: 110px;
    .adv_item {
      width: 192px;
      margin-right: 140px;
      &:last-child {
        margin-right: 0;
      }
      .img {
        width: 100%;
        height: 192px;
        box-sizing: border-box;
        border: 1px solid @themeColor;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }
      .p1 {
        margin-top: 32px;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
      }
      .p2 {
        padding: 0 8px 0 14px;
        box-sizing: border-box;
        margin-top: 16px;
        font-weight: bold;
        color: #595959;
        line-height: 18px;
      }
    }
  }
  .adv2 {
    .content {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      padding: 50px 96px 40px;
      .item {
        width: calc((100% - 320px) / 3);
        height: 276px;
        box-sizing: border-box;
        border: 1px solid @themeColor;
        border-top: none;
        margin-right: 160px;
        margin-bottom: 74px;
        padding: 0 20px;
        text-align: center;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .img {
          width: 66px;
          margin: 0 auto;
          margin-top: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: auto;
            height: auto;
            max-width: 100%;
          }
        }
        .title {
          margin-top: 18px;
          font-size: 20px;
          font-weight: bold;
          color: #000000;
        }
        .text {
          margin-top: 32px;
          color: #595959;
          line-height: 18px;
        }
      }
    }
  }

  .process {
    .content {
      height: 206px;
      box-sizing: border-box;
      margin-top: 100px;
      position: relative;
      .line {
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: -1px;
        width: 960px;
        height: 2px;
        display: flex;
        li {
          margin: 0 2px;
          width: 8px;
          height: 100%;
          background: #666666;
        }
        &::before,
        &::after {
          display: block;
          content: "";
          width: 20px;
          height: 20px;
          background: #666666;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -10px;
        }
        &::after {
          right: 0;
          left: auto;
        }
      }
      .item {
        width: 316px;
        box-sizing: border-box;
        position: absolute;
        display: flex;
        align-items: center;
        img {
          height: 76px;
          width: 56px;
          margin-right: 18px;
        }
        p {
          font-size: 20px;
          font-weight: 500;
          color: #333333;
        }
      }
      .pro1 {
        left: 186px;
        top: 0;
      }
      .pro2 {
        left: 502px;
        top: 0;
      }
      .pro3 {
        left: 818px;
        top: 0;
      }
      .pro4 {
        left: 28px;
        bottom: 0;
      }
      .pro5 {
        left: 344px;
        bottom: 0;
      }
      .pro6 {
        left: 660px;
        bottom: 0;
      }
    }
  }
  .about {
    .concat {
      margin-top: 38px;
      display: flex;
      .item {
        width: 526px;
        height: 242px;
        display: flex;
        flex-direction: column;
        align-items: center;
        line-height: 1;
      }
      .phone_box {
        background: #ffffd6;
        margin-right: 46px;
        .img {
          width: 60px;
          height: 52px;
          margin-top: 56px;
        }
        .p1 {
          margin-top: 28px;
          font-size: 18px;
          font-weight: bold;
          color: #000000;
        }
        .p2 {
          margin-top: 18px;
          font-size: 16px;
          font-weight: bold;
          color: #595959;
        }
      }
      .qr_code_box {
        background: #e3ecff;
        .img {
          margin-top: 20px;
          width: 170px;
          height: 172px;
        }
        .p1 {
          margin-top: 10px;
          font-size: 16px;
          font-weight: bold;
          color: #595959;
        }
      }
    }
    .map {
      display: block;
      margin-top: 20px;
      width: 1098px;
      height: 580px;
    }
  }
  .sign_up {
    margin-top: 82px;
    height: 250px;
    box-sizing: border-box;
    padding-top: 70px;
    background: #f8f8f8;
    text-align: center;
    .el-button {
      width: 250px;
      height: 50px;
      border: 1px solid #ff0000;
      padding: 0;
      border-radius: 0;
      font-size: 20px;
      font-weight: bold;
      color: #ff0000;
      &:active {
        position: relative;
        bottom: -2px;
        outline: 0;
      }
    }
  }
  /deep/ .el-dialog {
    .el-dialog__header {
      height: 6px;
      background: @themeColor;
      padding: 0;
    }
    .el-dialog__body {
      color: #666666;
      font-size: 14px;
      padding: 0;
      .header {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        line-height: 1;
        background: #f2f2f2;
        padding-bottom: 16px;
        h2 {
          font-size: 18px;
          font-weight: bold;
          margin-top: 22px;
        }
        .el-radio-group {
          margin-top: 16px;
          .el-radio__label {
            font-size: 18px;
            font-weight: bold;
            color: #666666;
          }
        }
        .itr {
          margin-top: 24px;
        }
      }
      .my_form {
        padding: 40px 138px 30px 0;
        .el-checkbox-group {
          height: 40px;
          .el-checkbox {
            margin-right: 14px;
          }
        }
        .append_btn {
          box-sizing: border-box;
          padding: 13px 20px; //字体14
          border-radius: 0;
          &:hover {
            color: @themeColor;
            border-color: rgb(255, 230, 188);
            background-color: rgb(255, 247, 233);
          }
          &:active {
            color: @themeColor;
            border-color: @themeColor;
            outline: 0;
          }
        }
        .append_btn.is-disabled,
        .append_btn.is-disabled:focus,
        .append_btn.is-disabled:hover {
          color: #c0c4cc;
          cursor: not-allowed;
          background-image: none;
          background-color: #fff;
          border-color: #ebeef5;
        }
        .btn {
          width: 300px;
          height: 36px;
          background: #e31d24;
          border: 1px solid #e31d24;
          border-radius: 5px;
          padding: 0;
          &:active {
            position: relative;
            bottom: -1px;
          }
        }
      }
    }
  }

  .com_title {
    font-size: 30px;
    font-weight: bold;
    color: #000000;
    padding-top: 100px;
  }
}
</style>